// Single source of truth lives in ./catalog.json (also read by the Ruby
// Escaleshop::FlowBuilder::Catalog service that powers the Captain flow catalog tool).
// Keep this file as a thin re-export so the ~13 importers stay unchanged.
import catalog from './catalog.json';

export const NODE_TYPES = catalog.nodeTypes;
export const NODE_CONFIG = catalog.nodeConfig;
export const TRIGGER_CATEGORIES = catalog.triggerCategories;
export const TRIGGER_EVENTS = catalog.triggerEvents;
export const ACTION_TYPES = catalog.actionTypes;
export const DELAY_UNITS = catalog.delayUnits;
export const NODE_PICKER_CATEGORIES = catalog.nodePickerCategories;
